import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

export const fetchRegisterQr = async (id: string): Promise<string> => {
  const response = await baseFetch(`${managerApiUrl}/staff/${id}/register_qr`, {
    customCache: true,
  });
  return JSON.stringify(response);
};

export const fetchLoginQr = async (id: string): Promise<string> => {
  const response = await baseFetch(`${managerApiUrl}/staff/${id}/auth_qr`, { customCache: true });
  return JSON.stringify(response);
};
